module.exports = "https://static.im-cdn.com/mjc/storefront/Melody/static/media/minus.c90e1ca8.svg";